import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { MatchPage } from './pages/MatchPage';
import { TablesPage } from './pages/admin/TablesPage';
import { TableFormPage } from './pages/admin/TableFormPage';
import { ButtonManagementPage } from './pages/admin/ButtonManagementPage';
import { CheckInPage } from './pages/table/CheckInPage';
import { TableStatusPage } from './pages/table/TableStatusPage';
import { CountdownPage } from './pages/table/CountdownPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/match/:matchId" element={<MatchPage />} />
        
        {/* Admin routes */}
        <Route path="/admin/tables" element={<TablesPage />} />
        <Route path="/admin/tables/new" element={<TableFormPage />} />
        <Route path="/admin/tables/:tableId/edit" element={<TableFormPage />} />
        <Route path="/admin/tables/:tableId/buttons" element={<ButtonManagementPage />} />
        
        {/* Table check-in and status routes */}
        <Route path="/table/:tableId/checkin/:qrType" element={<CheckInPage />} />
        <Route path="/table/:tableId/status" element={<TableStatusPage />} />
        <Route path="/table/:tableId/countdown/:matchId/:player1/:player2" element={<CountdownPage />} />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
